module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.45c4a46.ttf";